import React, {Component} from 'react';
import TableCreateAliquots from './TableCreateAliquots';
import Options from '../../general/options';
import Criterials from '../../general/criterials';
import moment from 'moment';
import WaitingModal from '../../../generics/WaitingModal';
import swal from 'sweetalert';
import Inputmask from 'inputmask';
import {Typeahead} from 'react-bootstrap-typeahead';
import SvgIcon from 'react-icons-kit';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';
import $ from 'jquery';

var Config = require('../../../../config');

class FormAliquots extends Component{
	constructor(props){
		super(props);

		this.getOption 	  = this.getOption.bind(this);
		this.getData 	  = this.getData.bind(this);
		this.getDataForm  = this.getDataForm.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSearch	  = this.onSearch.bind(this);
		this.isValidSearch = this.isValidSearch.bind(this);
		this.onChangeComponent = this.onChangeComponent.bind(this);
		this.printLabel = this.printLabel.bind(this);

		var aux_date = new Date();

		this.state = {
			option:"",

			equipment_type_list:[],
			equipment_type:"",
			equipment_id:"",

			aliquots:[],

			date:aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			hour:"",

			code_component:"",
			code_required:false,
			unit_number_required:false,

			process_id:"",
			blood_process:[],
			final_component_id:"",
			final_component:[],
			component_id:"",
			unit_number:"",
			component_number:"",
			component_numbers:[],
			component:[],
			code_component_list: [],

			isLoading: false,
			sistema:"",
			caducidad:"",

			reserved_list:[],
			alicuot_ids:[],
			preview_print:{},
			proc_unit_eq:{value:""},
			pending:false,
		}
	}

	validInputDate(message, id){
		if(message !== ""){
			swal('Error', message, 'error');
			
			setTimeout(()=>{
				$('#'+id).val('')
					.attr('type', 'text')
					.attr('type', 'date');
			}, 4000);

			$('#'+id).addClass('error');
		}else{
			$('#'+id).removeClass('error');
		}
	}

	componentDidMount(){
		$(document).on('blur', '#date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		$(document).on('blur', '#caducidad', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		if(selector !== null){
			im.mask(selector);

		}


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}
		
		this.props.onRef(this);
		this.setState({option: "Unit"});

		fetch(Config.default.apiGateway.URL+'equipments/by_health_facility?health_facilities_id='+
					sessionStorage.getItem("health_facilities_id")+'&type=separadora&active=true', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
	        }})
		.then(response => {
			this.setState({equipment_type_list: response});
		})

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				hour:hours,
			});
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=ALI_TYPE_SIS&x=', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			var datetime = moment(this.state.date+' '+this.state.hour).add(24, 'hours').format('YYYY-MM-DDTH:mm');
      			this.setState({sistema:response.value, caducidad:datetime});
      		}
      	});

      	fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		});

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PROC_UNIT_EQ&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				proc_unit_eq: response
			});
		});
	}

	printLabel(e){
		if(e !== ''){
			e.preventDefault();
		}
		
		this.props.waiting.handleShow('Imprimiendo...');
          
		var units = [];

		this.state.alicuot_ids.map((a)=>{
			units.push(a);
		});

		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea imprimir etiquetas?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Imprimir!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    },  (isConfirm)=> {
	        if (isConfirm) {
				fetch(Config.default.apiGateway.URL+'labelsEditor/print_bag_labels?health_facilities_id='+
					sessionStorage.getItem('health_facilities_id'), {
					method : 'post',
					body:JSON.stringify(units),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.blob();
					}else{
						res.text().then(function(result) {
							swal('¡Error!', result, 'error');
							return;
						});
					}
				}).then(response => {
					if(response !== undefined){
						if(this.state.preview_print.value === "NO"){
							//PREVIEW
							var fileURL = URL.createObjectURL(response);
							window.open(fileURL);
						}else{
							//PRINTER
							var reader = new FileReader();
							reader.readAsDataURL(response); 
							reader.onloadend = ()=> {
								var base64data = reader.result;  
								var aux = base64data.split(',');
								this.props.socket.send('{"Operacion":"print", "Type":"label_bags", "File": "'+aux[1]+'"}');
							}
						}

					}
				});
			}
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}
	
	handleChange(event){
		this.setState({[event.target.name] : event.target.value});
		
		if(event.target.name === 'hour'){
			var hour = moment(event.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || event.target.value.indexOf('-') !== -1){
				document.getElementById(event.target.id).classList.add("error");
				document.getElementById(event.target.name).style.borderColor = "red";
			}else{
				document.getElementById(event.target.name).style.borderColor = "#ccc";
				document.getElementById(event.target.id).classList.remove("error");
			}
		
		//Limpiar no. componente
		}else if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && event.target.value===""){
				control.classList.add('error');
			  }
			}
		}
	}

	getOption(option){
		this.setState({
			option:option,
			equipment_type:"",
			aliquots:[],
			code_component:"",
			unit_number:""
		});

		this.table.setState({
			component:[], 
			num_alicuots:""
		})
	}

	getData(result){
		this.setState({
			aliquots: result,
			code_component:"",
			unit_number:"",
			equipment_type:"",
			reserved_list:[]
		});

		this.table.setState({
			component:[],
			all:false,
			num_alicuots:"",
			target:[]
		});

		result.units.map((a, i)=>{
			if(a.reserved.length > 0){
				this.setState({
					reserved_list: [...this.state.reserved_list, {
						unit_id: a.unit.id,
						unit_number: a.unit.unit_number,
						component:a.component.code,
						component_number:a.unit.component_number,
						status: a.status,
						reserved: a.reserved
					}]
				});
			}

			
			return this.table.setState({
					component: [...this.table.state.component, {
						id:a.unit.id, 
						component:a.donation_number,
						volume:parseInt(a.unit.volume),
						component_number: a.unit.component_number,
						fraction: result.alicuots_created.length > 0 ? result.alicuots_created[i].count : 0,
						value:"", 
						input:"", 
						check:true,
						status:a.status,
						unit_number: a.unit.unit_number,
					}]
				})
		})

		setTimeout(function(){
			this.inputRef.focus();
		}.bind(this), 500);
	}

	getDataForm(){
		var obj = {};
		var aux = ""
		var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
		var hour = moment(this.state.hour, 'h:mm a');
		var table = "";

		table = this.table.getDataTable();

		if(table !== 'error' && table !== 'bloqueo'){
			obj.alicuots_process = {
				equipment_id   	: parseInt(this.state.equipment_id) || "",
				date 		  	: date.format('MM-DD-YYYY'),
				hour 			: this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm'),
				alicuots_parts  : table.input,
				number_target   : parseInt(this.table.state.num_alicuots) || 0
			}
			if(this.state.sistema === 'ABIERTO'){
				var caducidad = moment(this.state.caducidad, 'YYYY-MM-DD H:mm');
				obj.alicuots_process.caducidad = caducidad.format('MM-DD-YYYY H:mm');
			}
			
			obj.unit_completes = table.complete;
			obj.unit_incidents = table.incident;
			obj.health_facilities_id = sessionStorage.getItem('health_facilities_id');

		}else{
			obj.alicuots_process = {alicuots_parts:table};
			obj.unit_completes = [];
			obj.unit_incidents = [];
		}

		if(this.state.option === 'Unit'){
			document.getElementById('code_component').classList.remove("error");
	   		document.getElementById('unit_number').classList.remove("error");
	   	}

		return obj;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	onSearch(e){
		if(e.length > 0){
			
	   		var component = e[0].label.split(' ')[0];
			var number = e[0].label.split(' ')[1];
			this.setState({
	   			code_component: component,
	   			component_number: number,
	   			isLoading:true,
	   			//code_component_list:[],
	   			reserved_list:[],
	   			alicuot_ids:[]
	   		});

			//setTimeout(function(){
				if(this.isValidSearch()){
					this.setState({
						aliquots:[],
						components:[],
						blood_process:[],
					});

					this.table.setState({
						component:[]
					})

					this.waiting_modal.handleShow('Cargando...');
					fetch(Config.default.apiGateway.URL+'units/by_code_component?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
						'&code='+component+"&unit_number="+this.state.unit_number+"&component_number="+number+'&process=alicuots', {
						method : 'get',
						headers: new Headers({
							'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					})
					.then(res => {
						this.waiting_modal.handleClose();
				        if(res.ok){
				          return res.json();
				        }else{
				          res.text().then(function(result) {
				            swal('¡Error!', result, 'error');
				            return;
				          });
				        }})
					.then(response => {
						if(response !== undefined){
							var valid = true;
							if(response.units.length > 0){
								console.log(response)
								switch(response.units[0].length){
									case 0 :
										swal('Búsqueda sin resultados', "", 'warning');
										break;
									case 1://Busqueda exitosa
										response.units.map(function(u, x){
											return u.map((d, i)=>{
												if(d.status !== 'BLOQUEADA'){
													this.setState({aliquots: [...this.state.aliquots, d]});
													
													this.table.setState({
														component:[...this.table.state.component, 
																  {
																	id:d.unit.id, 
																	component:d.donation_number,
																	volume:parseInt(d.unit.volume), 
																	component_number: d.unit.component_number,
																	fraction: response.alicuots_created.length > 0 ? response.alicuots_created[0].count : 0,
																	value:"", 
																	input:"", 
																	check:true,
																	final_volume:parseFloat(d.unit.volume),
																	component_type:d.blood_component.component_type
																  }]
													})

													if(d.reserved.length > 0){
														this.setState({
															reserved_list: [...this.state.reserved_list, {
																unit_id: d.unit.id,
																component:d.blood_component.code,
																component_number:d.unit.component_number,
																unit_number:d.unit.unit_number,
																status: d.status,
																reserved: d.reserved,
																component_type:d.blood_component.component_type
															}]
														});
													}
												}else{ 
													valid = false;
												}

												if(d.status === 'PENDIENTE DE VALIDAR' || d.status === 'RECHAZADA LABORATORIO'){
													this.setState({
														pending:true
													})
												}
													
											})
												
										}.bind(this));

										if(valid){

											this.setState({
												component_id:response.blood_component.id,		
												code_component:"",
												unit_number:"",
												component_number:"",
												component_numbers:[],

												value:"",
												suggestions:[],
												code_component_list:[],
											});

											response.blood_component_has_blood_process.map(function(blood, i){
												return this.setState({
													blood_process : [...this.state.blood_process, blood]
												})
											}.bind(this));

											setTimeout(function(){
												this.inputRef.focus();
											}.bind(this), 500);
										}else{
											swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');

											this._typeahead.getInstance().blur();
											this._typeahead.getInstance().clear();
										}
										break;
										
									default://Seleccionar numero de componente
										
										response.units.map((u)=>{
											return u.map((d, i)=>{
												if(d.unit.component_number === this.state.component_number){
													if(d.status !== 'BLOQUEADA'){
														this.setState({aliquots: [...this.state.aliquots, d]});

														this.table.setState({
															component:[...this.table.state.component, 
																	  {
																		id:d.unit.id, 
																		component:d.donation_number,
																		volume:parseInt(d.unit.volume), 
																		component_number: d.unit.component_number,
																		fraction: response.alicuots_created.length > 0 ? response.alicuots_created[0].count : 0,
																		value:"", 
																		input:"", 
																		check:true,
																		final_volume:parseFloat(d.unit.volume),
																		component_type:d.blood_component.component_type
																	  }]
														})

														if(d.reserved.length > 0){
															this.setState({
																reserved_list: [...this.state.reserved_list, {
																	unit_id: d.unit.id,
																	unit_number: d.unit.unit_number,
																	component:d.blood_component.code,
																	component_number:d.unit.component_number,
																	status: d.status,
																	reserved: d.reserved,
																	component_type:d.blood_component.component_type
																}]
															});
														}

														if(d.status === 'PENDIENTE DE VALIDAR' || d.status === 'RECHAZADA LABORATORIO'){
															this.setState({pending: true});
														}

														this.setState({
															component_id:response.blood_component.id,		
															code_component:"",
															unit_number:"",
															component_number:"",
															component_numbers:[]
														});

														response.blood_component_has_blood_process.map(function(blood, i){
															return this.setState({
																blood_process : [...this.state.blood_process, blood]
															})
														}.bind(this));

														setTimeout(function(){
															this.inputRef.focus();
														}.bind(this), 500);
													}else{
														valid = false;
													}
												}
													
											})
												
										})

										if(!valid){
											swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');

											this._typeahead.getInstance().blur();
											this._typeahead.getInstance().clear();
										}

										
									break;
								}


							}else{
								swal('Búsqueda sin resultados', "", 'warning');
							}
							
						}
					});

					this.setState({
			   			isLoading:false,
			   			code_component_list:[]
			   		});

			   		this.table.setState({num_alicuots:'2'});
					this._typeahead.getInstance().blur();
					this._typeahead.getInstance().clear();
				}else{
					swal('Búsqueda sin resultados', "", 'warning');
				}
			//}.bind(this), 500);

			
				
		}		
	}

	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}


	    return isFormValid;
	}

	getProcess(e){
		var index = e.nativeEvent.target.selectedIndex;
		this.setState({
			[e.target.name]: e.target.value,
		});

		var proc =  e.nativeEvent.target[index].text;

		fetch(Config.default.apiGateway.URL+'blood_process/transformation_process?process='+proc+
			'&blood_component_id='+this.state.component_id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			}) 
		})
		.then(res => res.json())
		.then(response =>{
			this.setState({
				final_component:response,
				final_component_id:""
			})
		});
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		
  			e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
      		      		
		}
  	}

  	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			//this.validateInput(e);

			fetch(Config.default.apiGateway.URL+'units/alicouts_search?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
				'&unit_number='+e.target.value, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					this.setState({
						code_component_list: response
					})
					
					this._typeahead.getInstance().focus();
				}

			})

		}
	}

	onChangeComponent(e){
	}

	render(){
		return (
			<div className="col-xs-12">
				
				<fieldset>
					<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
					<div className="col-xs-12 col-sm-2" style={{paddingRight:"0"}}>
						<Options {...this.props} validate={this.validateInput} sendData={this.getOption} onRef={ref => (this.options = ref)} />
					</div>

					<div className="col-xs-12 col-sm-10">
						{this.state.option === 'Block' ?
							<Criterials {...this.props} validate={this.validateInput} sendData={this.getData} onRef={ref => (this.criterials = ref)} />

						: 	<div className="col-xs-12 col-sm-12">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-2">
										<span className="span-min">No de Unidad</span>
										<input className={this.state.unit_number_required ? "form-control error" : "form-control"} type="text" 
											id = "unit_number" name="unit_number" onKeyPress={(e) => this.searchComponent(e)} onChange={this.handleChange}
											value={this.state.unit_number || ""} />
									</div>

									<div className="col-xs-12 col-sm-2" style={{paddingLeft:"0px"}}>
										<span className="span-min">Código componente</span>
										
										<Typeahead
								          	/*{...this.state}*/
								          	labelKey={(option) => `${option.label}`}
								          	minLength={0}
								          	options={this.state.code_component_list.length > 0 ? this.state.code_component_list : []}
								          	onChange={this.onSearch}	
								            inputProps={{
								          		name:"code_component",
								          		id:"code_component"
								          	}}
								          	id="codeComponent"
								          	isLoading={this.state.isLoading}
								          	ref={ref => this._typeahead = ref}
								          	delay={600}
								          	paginationText="Mostrar mas resultados..."
								        />

									</div>
								</div>
							</div>
						}
					</div>
				</fieldset>

				<fieldset>
					<legend style={{fontSize:"1.5em", marginBottom:"10px"}}>Proceso</legend>
					
					<div className="col-xs-12 col-sm-9 col-sm-offset-1">
						<div className="col-xs-12 form-group" style={{paddingLeft:"3em"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right", paddingRight:"1em"}}>
								<span>Fecha</span>
							</div>
							<div className="col-xs-12 col-sm-2" style={{padding:"0", width:"17.5%"}}>
								<input className="form-control" type="date" id="date" name="date" ref={(input) => { this.inputRef = input }}
									onChange={this.handleChange} value={this.state.date || ""} onKeyPress={(e) => this.validateInput(e)} required />
							</div>

							<div className="col-xs-12 col-sm-1" style={{paddingLeft:"19px"}}>
								<span>Hora</span>
							</div>
							<div className="col-xs-12 col-sm-2" style={this.state.option === 'Unit' ? {padding:"0", width:"20.2%"} : {padding:"0", width:"11.2%"}}>
								<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
									data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
									required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
							</div>

						</div>


						<div className="col-xs-12 form-group" style={{paddingLeft:"3em"}}>
							<div className="col-xs-12 col-sm-2" style={{textAlign:"right", paddingRight:"1em"}}>
								<span>Equipo</span>
							</div>
							<div className={this.state.option === 'Unit' ? "col-xs-12 col-sm-6" : "col-xs-12 col-sm-5"} style={{padding:"0"}}>
								<select className="form-control" name="equipment_id" id="equipment_id" 
									style={this.state.option === 'Unit' ? {width:"92%"} : {width:"89%"}}
									value={this.state.equipment_id || ""} onChange={this.handleChange} 
									onKeyPress={(e) => this.validateInput(e)}>
									<option value="">Seleccione...</option>
									{this.state.equipment_type_list.map((eq, i)=>(
										<option key={eq.id} value={eq.id}>{eq.name}</option>
									))}
								</select>
							</div>
						</div>

						{this.state.sistema === 'ABIERTO' ?
							<div className="col-xs-12" style={{paddingLeft:"3em"}}>
								<div className="col-xs-12 col-sm-2" style={{textAlign:"right", paddingRight:"1em"}}>
									<span>Caducidad</span>
								</div>
								<div className={this.state.option === 'Unit' ? "col-xs-12 col-sm-6" : "col-xs-12 col-sm-5"} style={{padding:"0"}}>
									<input type="datetime-local" value={this.state.caducidad || ""} onKeyPress={(e) => this.validateInput(e)} 
										onChange={this.handleChange} id="caducidad" name="caducidad" className="form-control" 
										style={this.state.option === 'Unit' ? {width:"92%"} : {width:"89%"}}/>
								</div>
							</div>
						:null}
					</div>

					<hr style={{width:"100%"}}/>
					
					<TableCreateAliquots validate={this.validateInput} state={this.state} {...this.props} onRef={ref => (this.table = ref)} />

					{this.state.option !== 'Block' ?
						<div className="col-xs-12 form-group" style={{marginTop:'10px', textAlign:'center'}}>
							<button className="toolIcon" onClick={this.printLabel}
								disabled={this.state.pending ? true : this.state.alicuot_ids.length === 0}>
								<SvgIcon size={40} icon={priceTag} />
								<div className="col-xs-12">
									<span>Etiqueta</span>
								</div>
							</button>
						</div>
					:null}
				</fieldset>

				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
			
	}
}

export default FormAliquots;